// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const Executor = {
  "NA": "NA",
  "NEXTFLOW": "NEXTFLOW",
  "CROMWELL": "CROMWELL",
  "INGEST": "INGEST"
};

const Repository = {
  "NA": "NA",
  "NFCORE": "NFCORE",
  "GITHUBPUBLIC": "GITHUBPUBLIC",
  "GITHUBPRIVATE": "GITHUBPRIVATE",
  "AWS": "AWS"
};

const Status = {
  "PENDING": "PENDING",
  "RUNNING": "RUNNING",
  "DELETE": "DELETE",
  "DELETING": "DELETING",
  "FAILED": "FAILED",
  "COMPLETED": "COMPLETED",
  "ARCHIVED": "ARCHIVED",
  "DELETED": "DELETED"
};

const { Log, Process, Dataset, Project, Billing, Compute, KeyValue, Code, Parameters, Budget, Contact } = initSchema(schema);

export {
  Log,
  Process,
  Dataset,
  Project,
  Billing,
  Executor,
  Repository,
  Status,
  Compute,
  KeyValue,
  Code,
  Parameters,
  Budget,
  Contact
};